const STORAGE_PREFIX = 'gb-soft-prompt-dismissed:';

function storageKey(promptId, treeId = null) {
  return `${STORAGE_PREFIX}${promptId}:${treeId || 'global'}`;
}

/** Session-scoped dismissal — survives re-renders, clears when the tab closes. */
export function isPromptDismissed(promptId, treeId = null) {
  try {
    return sessionStorage.getItem(storageKey(promptId, treeId)) === '1';
  } catch {
    return false;
  }
}

export function dismissPrompt(promptId, treeId = null) {
  try {
    sessionStorage.setItem(storageKey(promptId, treeId), '1');
  } catch {
    // Ignore private-mode / quota errors — prompt may reappear this session.
  }
}

export function clearPromptDismissal(promptId, treeId = null) {
  try {
    sessionStorage.removeItem(storageKey(promptId, treeId));
  } catch {
    // no-op
  }
}
